/**
 * Document Studio analytics actions
 */
export const DOCUMENT_STUDIO_ACTIONS = {
  GENERATION_STARTED: 'generation_started',
  GENERATION_COMPLETED: 'generation_completed',
  SLIDE_EDITED: 'slide_edited',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  CHAT_MESSAGE_SENT: 'chat_message_sent',
  TEMPLATE_SELECTED: 'template_selected',
} as const;
